module.exports = __webpack_public_path__ + "static/img/jp8.d08eea1d.png";